import React, { useState, useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Embed, factories, IEmbedConfiguration, service } from 'powerbi-client'; 
import { models } from 'powerbi-client'; 
import { reportsService } from '../../../service/reports.service'; 

const PowerBIEmbed = ({ reportName }: { reportName: string }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const reportContainer = useRef<HTMLDivElement>(null);
  
  const powerbi = new service.Service(
    factories.hpmFactory, 
    factories.wpmpFactory,
    factories.routerFactory
  );

  useEffect(() => {
    let report: Embed;

    const embedReport = async () => {
      try {
        setLoading(true);
        
        const data = await reportsService.getEmbedToken(reportName);

        const config: IEmbedConfiguration = {
          type: 'report',
          id: data.reportId,
          embedUrl: data.embedUrl,
          accessToken: data.accessToken,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: false }
            }
          }
        };

        if (reportContainer.current) {
          report = powerbi.embed(reportContainer.current, config);
        }
        
      } catch (err) {
        console.error(err);
        setError("Error loading Power BI Report");
      } finally {
        setLoading(false);
        if (!error) setError(null); 
      }
    };

    embedReport();

    return () => {
      if (reportContainer.current) {
        powerbi.reset(reportContainer.current);
      }
    };
  }, [reportName]);

  return (
    <Box sx={{ width: '100%', height: '600px', position: 'relative', bgcolor: '#f5f5f5', borderRadius: 2, border: '1px solid #ddd', overflow: 'hidden' }}>
      <div ref={reportContainer} style={{ width: '100%', height: '100%', display: loading || error ? 'none' : 'block' }} />
   
      {loading && (
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(255,255,255,0.8)', zIndex: 2 }}>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography color="textSecondary">Loading Power BI Report...</Typography>
        </Box>
      )}

      {error && (
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3, zIndex: 2 }}>
          <Typography color="error" variant="h6">{error}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default PowerBIEmbed;